document.addEventListener("DOMContentLoaded",async () => {
    const dialog = document.querySelector(".real-life-images-container");
    const closeBtns = document.querySelectorAll(".real-life-images-close-btn");
    const openBtns = document.querySelector(".real-life-images-btn");
    const varientBtns = document.querySelectorAll(".real-life-images-container .varient-selector button");
    const variantImages = document.querySelectorAll(".real-life-images-container .image-list .variant-image-list");
    // const mobile_animation = document.querySelector(".real-life-images-btn div");
    const innerDialog = document.querySelector('.real-life-images-container .inner-dialog');
    closeBtns.forEach((btn) => btn.addEventListener("click", closeRealLifeImagesPopup));

    function settActiveVarientId(){
        var selectedSwatch = document.querySelector(
          ".product-landing-section .color-container .color-swatch.selected"
        );
        var selectedVariantId;
        // saperate logic for chair and desk
        if(!selectedSwatch){
          var priceContainer = document.querySelector(
          ".product-landing-section.desk .price-container.active");
          selectedVariantId = priceContainer.dataset.variantColor;
        }else{
          var selectedSwatchParentColorContainer = selectedSwatch.parentElement;
          selectedVariantId = selectedSwatchParentColorContainer.dataset.variantId;  
        }
        // check if selectedVariantId is disabled
        selectedVariantId = selectedVariantId.trim();
        if(isDisabled(selectedVariantId)){
            selectedVariantId = setFirstNonDisabledId();
        }
        variantImages.forEach((images) => {toggleCurrentVarient(images,selectedVariantId)});
        varientBtns.forEach((btn) => {toggleCurrentVarient(btn,selectedVariantId)});

    }

    function setFirstNonDisabledId(){
        for (let btn of varientBtns) {
            if(!btn.classList.contains('disable'))
                return btn.getAttribute("data-id");
        }
        return null;
    }

    function isDisabled(selectedVariantId) {
        for (let btn of varientBtns) {
            if (btn.getAttribute("data-id").trim() === selectedVariantId) {
                return btn.classList.contains('disable');
            }
        }
        return null;
    }
    
    openBtns.addEventListener("click", () => {
        dialog.showModal();
        history.pushState({ dialogOpen: true }, ""); // Add to history
        settActiveVarientId();
    });

    varientBtns.forEach((btn) => {
        if(!btn.classList.contains('disable'))
            btn.addEventListener("click", changeVariant)
    });

    function changeVariant(event){
        const varientId = event.target.getAttribute("data-id");
        variantImages.forEach((images) => {toggleCurrentVarient(images,varientId)});
        varientBtns.forEach((btn) => {toggleCurrentVarient(btn,varientId)});
    }

    function toggleCurrentVarient(ele,varientId){
        const imagesVarientId = ele.getAttribute("data-id");
        if(imagesVarientId === varientId){
            ele.classList.add("active");
        }else{
            ele.classList.remove("active");
        }
    }
    
    function closeRealLifeImagesPopup(){
        dialog.close(); 
        history.back(); // Simulate back press without leaving the page
    }

    // mobile animation
    // mobile_animation.classList.add("complete") // Or any maximum size you want
    
    // After the transition completes (600ms in this case), collapse back to 0
    // setTimeout(() => {
    //     mobile_animation.classList.remove("complete") // Or any maximum size you want
    // }, 5000);
    dialog.addEventListener("click", (event) => {
        if (event.target === dialog) {
            closeRealLifeImagesPopup();
        }
    }); 

    window.addEventListener("popstate", (event) => {
        if (dialog.open) {
          dialog.close();
        }
    });

    innerDialog.addEventListener('click', (event) => event.stopPropagation());
})